import { jsx as _jsx } from "react/jsx-runtime";
import cx from "classnames";
import { Text } from "@cinch-labs/design-system";
import { LOADING_TEXT } from "../../constants";
import skeletonStyles from "../../skeleton.module.css";
import styles from "./subtitle.module.css";
const Subtitle = ({ children , isPending =false , className ="" , fontSize  })=>{
    const isChildrenAString = typeof children === "string";
    const content = isChildrenAString ? /*#__PURE__*/ _jsx("span", {
        dangerouslySetInnerHTML: {
            __html: children
        }
    }) : children;
    return /*#__PURE__*/ _jsx(Text, {
        fontSizeFixed: fontSize || "xs",
        className: cx(className, styles["subtitle"], {
            [skeletonStyles["base"]]: isPending,
            [skeletonStyles["active"]]: isPending
        }),
        children: isPending ? LOADING_TEXT : content
    });
};
export default Subtitle;
